import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import Markdown from "@/components/Markdown";

const TITLES = {
  impressum: "Impressum",
  datenschutz: "Datenschutz",
};

export default function LegalModal({ field, open, onClose }) {
  const { settings } = useSiteSettings();
  const [scrollLock, setScrollLock] = useState(false);

  useEffect(() => {
    if (!open) return;
    setScrollLock(true);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
      setScrollLock(false);
    };
  }, [open, onClose]);

  if (!open) return null;
  const text = (settings?.[field] || "").trim();
  const title = TITLES[field] || field;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid={`legal-modal-${field}`}
      aria-modal="true"
      role="dialog"
    >
      <div
        className="card-surface max-w-3xl w-full max-h-[88vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-white/10 shrink-0">
          <div>
            <div className="eyebrow text-[#00E5FF]">Rechtliches</div>
            <h2 className="font-display font-black italic uppercase text-2xl mt-1">{title}</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-neutral-400 hover:text-white p-1.5 border border-white/10 hover:bg-white/5"
            aria-label="Schließen"
            data-testid={`legal-modal-${field}-close`}
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-6">
          {text ? <Markdown>{text}</Markdown> : (
            <p className="text-sm text-neutral-500 italic">Inhalt noch nicht hinterlegt.</p>
          )}
        </div>
      </div>
    </div>
  );
}
